<script setup lang="ts">
const to = defineModel<string>('to', { default: '' })

const { getRedirectedPath } = useGetRedirectedPath()
const redirectedTo = getRedirectedPath({ routeName: to })
if (redirectedTo) {
  to.value = redirectedTo
}
</script>

<template>
  <NuxtLink :to="to">
    <slot />
  </NuxtLink>
</template>
